export default __webpack_public_path__ + "static/logo-3f62a146dc5acbfa510dc3e51a115e65.svg";